export default __webpack_public_path__ + "alberta-activity-endtime.68fb79ca7ac4dae2038e.svg";